import { getContainingComponent } from "ceres/app/helper/utils";

const browserDetect = require("detect-browser");
const NotificationService = require("ceres/app/services/NotificationService");
const AutoFocusService = require("ceres/app/services/AutoFocusService");

import Vue from "vue";
import { getStyle } from "ceres/app/helper/dom";
import { detectPassiveEvents } from "ceres/app/helper/featureDetect";
import HeaderScroller from "ceres/app/helper/HeaderScroller";

// Frontend end scripts
// eslint-disable-next-line
const headerCollapses = [];

function HeaderCollapse(selector)
{
    headerCollapses.push(selector);
    $(function()
    {
        $(selector).on("show.bs.collapse", () =>
        {
            headerCollapses.forEach(element =>
            {
                if (!$(element).is(selector))
                {
                    $(element).collapse("hide");
                }
            });
        });

    });
}

function CeresMain()
{
    const browser = browserDetect.detect();

    if (browser && browser.name)
    {
        $("html").addClass(browser.name);
    }
    else
    {
        $("html").addClass("unkown-os");
    }

    // Detect Facebook integrated Browser
    if (typeof navigator !== "undefined" && /FBA[NV]\/([0-9\.]+)/.test(navigator.userAgent))
    {
        document.body.classList.add("facebook");
    }

    const isDesktop =  window.matchMedia("(min-width: 992px)").matches;
    const isTablet =  window.matchMedia("(min-width: 768px)").matches;
    const isMobile =  window.matchMedia("(max-width: 767px)").matches;

    $(window).scroll(function()
    {
        if ($(".wrapper-main").hasClass("isSticky"))
        {
            if ($(this).scrollTop() > 1)
            {
                $(".wrapper-main").addClass("sticky");
            }
            else
            {
                $(".wrapper-main").removeClass("sticky");
            }
        }

        // lg header anpassung
        if ($(this).scrollTop() > 40 && isTablet)
        {
            $(".dia-top-bar, .dia-shop-nav, .banner-widget__wrapper").addClass("hide-on-scroll");
            $(".dia-navbar__wrapper").addClass("show-on-scroll");
            $(".dia-header").removeClass("unfixed");
        }
        else if($(this).scrollTop() <= 40 && isTablet)
        {
            $(".dia-top-bar, .dia-shop-nav, .banner-widget__wrapper").removeClass("hide-on-scroll");
            $(".dia-navbar__wrapper").removeClass("show-on-scroll");
            $(".dia-header").addClass("unfixed");
        }else if($(this).scrollTop() > 40 && !isTablet){
            $('.banner-widget__wrapper').addClass("hide-on-scroll");
        }else if($(this).scrollTop() <= 40 && !isTablet){
            $('.banner-widget__wrapper').removeClass("hide-on-scroll");
        }

        if($(this).scrollTop() >= 100 && isMobile && $('.category-controls__wrapper').length > 0){
            $('.category-controls__wrapper').addClass("sticky-filter");
        }else if($(this).scrollTop() < 100 && isMobile && $('.category-controls__wrapper').length > 0){
            $('.category-controls__wrapper').removeClass("sticky-filter");
        }
    });

    window.onpopstate = function(event)
    {
        if (event.state && event.state.requireReload)
        {
            window.location.reload();
        }
    };

    // init bootstrap tooltips
    document.querySelectorAll("[data-toggle=\"tooltip\"]").forEach(el =>
    {
        $(el).tooltip();
    });

    HeaderCollapse("#countrySettings");
    HeaderCollapse("#currencySelect");
    HeaderCollapse("#searchBox");

    const $mainNavbarCollapse = $("#mainNavbarCollapse");

    // prevent hidding collapses in the shopbuilder, for editing search bar results
    if (!App.isShopBuilder)
    {
        $(document).on("click", function(evt)
        {
            headerCollapses.forEach(element =>
            {
                if (evt.target !== element && $(evt.target).parents(element).length <= 0)
                {
                    $(element).collapse("hide");
                }
            });
        });
    }

    $mainNavbarCollapse.collapse("hide");

    // Add click listener outside the navigation to close it
    $mainNavbarCollapse.on("show.bs.collapse", function()
    {
        $(".main").one("click", closeNav);
    });

    $mainNavbarCollapse.on("hide.bs.collapse", function()
    {
        $(".main").off("click", closeNav);
    });

    function closeNav()
    {
        $("#mainNavbarCollapse").collapse("hide");
    }

    $(function()
    {
        const offset = 250;
        const duration = 300;

        let isDesktop = window.matchMedia("(min-width: 768px)").matches;

        AutoFocusService.autoFocus();

        $("#searchBox").on("shown.bs.collapse", function()
        {
            const searchInput = document.querySelector("input.search-input");

            if (searchInput)
            {
                searchInput.focus();
            }
        });

        window.addEventListener("scroll", function()
        {
            if (isDesktop)
            {
                if ($(window).scrollTop() > offset)
                {
                    $(".back-to-top").fadeIn(duration);
                    $(".back-to-top-center").fadeIn(duration);
                }
                else
                {
                    $(".back-to-top").fadeOut(duration);
                    $(".back-to-top-center").fadeOut(duration);
                }
            }
        }, detectPassiveEvents() ? { passive: true } : false );

        window.addEventListener("resize", function()
        {
            isDesktop = window.matchMedia("(min-width: 768px)").matches;
        });

        $(".back-to-top").on("click", function(event)
        {
            event.preventDefault();

            $("html, body").animate({ scrollTop: 0 }, duration);

            return false;
        });

        $(".back-to-top-center").on("click", function(event)
        {
            event.preventDefault();

            $("html, body").animate({ scrollTop: 0 }, duration);

            return false;
        });

        $("#accountMenuList").on("click", function()
        {
            $("#countrySettings").collapse("hide");
            $("#searchBox").collapse("hide");
            $("#currencySelect").collapse("hide");
        });

        fixPopperZIndexes();

        // Emit event for Sticky Containers to update
        $(".collapse").on("show.bs.collapse hide.bs.collapse", function()
        {
            this.dispatchEvent(new CustomEvent("updateStickyContainer",
                {
                    bubbles: true
                }));
        });

        $(".category-controls__toggle-filter").click(function(ev)
        {
            ev.preventDefault();
            $(".category-controls__filter").toggleClass("is-open");
            $(this).toggleClass("is-open");
        });

        $('.single__read-more a').click(function(ev){
            ev.preventDefault();

            let offset = $('.od-description-container').offset().top;

            $('html, body').animate({
                scrollTop: offset - 100
            }, 1000);

            document.getElementsByClassName("single-item__description")[0].children[0].classList.add("full");
        });

        $(document).click(function(ev){
            let $target = $(ev.target);
            if($target[0].className == 'modal-backdrop' && $("body").hasClass('quick-view-open')){
                // close
                let elem = $('body > .category-item__quick-view-item-modal .btn-close')[0]; // Element to fire on
                elem.dispatchEvent(new Event("click"));
            }
        });

        if(window.location.pathname.includes("/trends")){
            $('.dia-shop-nav__main-nav a[href="/trends"]').addClass("is-active");
        }else if(window.location.pathname.includes("/herren")){
            $('.dia-shop-nav__main-nav a[href="/herren"]').addClass("is-active");
        }else if(window.location.pathname.includes("/damen")){
            $('.dia-shop-nav__main-nav a[href="/damen"]').addClass("is-active");
        }else{
            if($(".breadcrumbs").length && $(".breadcrumbs").html().includes("Trends")){
                $('.dia-shop-nav__main-nav a[href="/trends"]').addClass("is-active");
            }else if($(".breadcrumbs").length && $(".breadcrumbs").html().includes("Herren")){
                $('.dia-shop-nav__main-nav a[href="/herren"]').addClass("is-active");
            }else{
                $('.dia-shop-nav__main-nav a[href="/damen"]').addClass("is-active");
            }
        }

        $(function () {
            $('[data-toggle="popover"]').popover()
        })

        if($("body").hasClass("page-confirmation")){
            $('.cmp-totals dt').each(function(index, item){
                let str = $(item).text().replace(/<[^>]*>?/gm, '').trim();
                if(str.indexOf("Brutto") > -1){
                    str = str.substring(0, str.length - 9);
                    $(item).text(str);
                }
            })
        }

        if($(".page-confirmation").length){
            $('.totalSum dd').addClass("sum-with-vat-info").html($('.totalSum dd').html() + "<br/><span class=\"totalSum__txt\" style=\"\n" +
                "    font-weight: normal;\n" +
                "    font-size: 80%;\n" +
                "\">inkl. MwSt. inkl. <a href='/zahlung-und-versand' target='_blank'>Versand</a></span>");
        }

        $('.seo-text__collapse-toggle--not-vue').click(function(ev){
            ev.preventDefault();
            $(".seo-text__collapsable--not-vue").toggleClass('is-open');
        });


        $(".pop").popover({ trigger: "manual" , html: true, animation:false})
            .on("mouseenter", function () {
                var _this = this;
                $(this).popover("show");
                $(".popover").on("mouseleave", function () {
                    $(_this).popover('hide');
                });
            }).on("mouseleave", function () {
            var _this = this;
            setTimeout(function () {
                if (!$(".popover:hover").length) {
                    $(_this).popover("hide");
                }
            }, 300);
        });

        setTimeout(function(){
            const app = document.getElementById("vue-app");
            if(app.style.marginTop === "50px"){
                app.style.marginTop = "163px";
            }
        }, 1000);

    });
}

window.CeresMain = new CeresMain();
window.CeresNotification = NotificationService;

const showShopNotification = function(event)
{
    if (event.detail.type)
    {
        switch (event.detail.type)
        {
        case "info":
            NotificationService.info(event.detail.message);
            break;
        case "log":
            NotificationService.log(event.detail.message);
            break;
        case "error":
            NotificationService.error(event.detail.message);
            break;
        case "success":
            NotificationService.success(event.detail.message);
            break;
        case "warning":
            NotificationService.warn(event.detail.message);
            break;
        default:
            console.log("no type such as:" + event.detail.type);
            break;
        }
    }
};

document.addEventListener("showShopNotification", showShopNotification);

// fixate the header elements
new HeaderScroller();

$(document).on("shopbuilder.after.drop shopbuilder.after.widget_replace", function(event, eventData, widgetElement)
{
    const parent = widgetElement[1];

    const parentComponent = getContainingComponent(parent);

    const compiled = Vue.compile(widgetElement[0].outerHTML, { delimiters: ["${", "}"] } );
    const component = new Vue({
        store: window.ceresStore,
        render: compiled.render,
        staticRenderFns: compiled.staticRenderFns,
        parent: parentComponent
    });

    component.$mount( widgetElement[0] );
    $(component.$el).find("*").each(function(index, elem)
    {
        $(elem).on("click", function(event)
        {
            event.preventDefault();
        });
    });

    $(component.$el).find(".owl-carousel").on("resized.owl.carousel", function()
    {
        window.dispatchEvent(new Event("resize"));
    });
});

function fixPopperZIndexes()
{
    const elements = document.querySelectorAll(".popover.d-none");

    let counter = elements.length;

    elements.forEach(el =>
    {
        let zIndex = parseInt(getStyle(el, "z-index"));

        if (!isNaN(zIndex))
        {
            zIndex += --counter;

            el.style.zIndex = zIndex;
        }
    });
}
